<template>
  <v-layout
    wrap
    align-baseline
    style="line-height: normal"
  >
    <div
      class="caption mr-2 mb-1"
      :class="[textClass]"
    >
      {{ $t('contentActiveViaAutomation') }}
      <router-link :to="{name: 'workspace'}">
        {{ entry.automation_name }}
      </router-link>
    </div>
  </v-layout>
</template>

<script>
export default {
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      textClass: 'grey--text text--darken-1',
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/ViaAutomation.vue